<template>
    <div class="bg-white rounded-lg shadow p-4 mb-4">
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <slot></slot>
        </div>
        
        <!-- Pulsanti azione -->
        <div class="mt-4 flex justify-end">
            <Button
                label="Cerca"
                icon="pi pi-search"
                @click="$emit('search')"
                :loading="loading"
            />
        </div>
    </div>
</template>

<script setup>
defineProps({
    loading: {
        type: Boolean,
        default: false
    }
});

defineEmits(['search']);
</script>